













































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { UserInfo } from "@/pbjs/xcommon/enum_pb";
import { jsIntString,timeFormatSecond } from "@/utils";

const baseInfo = () => import("@/views/peopleManagement/components/peopleBaseInfo.vue");
const identity = () => import("@/views/peopleManagement/components/identity.vue");
const work = () => import("@/views/peopleManagement/components/work.vue");
const family = () => import("@/views/peopleManagement/components/family.vue");
const occupancy = () => import("@/views/peopleManagement/components/occupancy.vue");
const reward = () => import("@/views/peopleManagement/components/reward.vue");


@Component({
    name: "peopleInfo",
    components: { baseInfo,identity,work,family,occupancy,reward }
})

export default class CombinationProperty extends Vue {
    @Provide() private userid: any = '';//用户管理里的userid
    @Provide() private archiveid: any = '';//archiveid

    @Provide() private showPanelRecord: Boolean = false;//入离职记录
    @Provide() private showPanelDialog: Boolean = false;//入离职记录弹出框
    @Provide() private panelRecord: any = [];//入离职记录列表

    @Provide() private baseUserInfo: any = {};//用户管理带过来的用户基本信息
    @Provide() private detailInfo: any = {};//详情信息  需要传给子组件的

    @Provide() private baseAdd: Boolean = false;//是否为新增
    @Provide() private identityAdd: Boolean = false;//是否为新增
    @Provide() private workAdd: Boolean = false;//是否为新增
    @Provide() private familyAdd: Boolean = false;//是否为新增
    @Provide() private occupancyAdd: Boolean = false;//是否为新增
    @Provide() private rewardAdd: Boolean = false;//是否为新增

    @Provide() private baseDetail: Boolean = false;//是否为查看
    @Provide() private identityDetail: Boolean = false;//是否为查看
    @Provide() private workDetail: Boolean = false;//是否为查看
    @Provide() private familyDetail: Boolean = false;//是否为查看
    @Provide() private occupancyDetail: Boolean = false;//是否为查看
    @Provide() private rewardDetail: Boolean = false;//是否为查看

    @Provide() private baseLoading:Boolean = false;//loading
    @Provide() private identityLoading:Boolean = false;//loading
    @Provide() private workLoading:Boolean = false;//loading
    @Provide() private familyLoading:Boolean = false;//loading
    @Provide() private occupancyLoading:Boolean = false;//loading
    @Provide() private rewardLoading:Boolean = false;//loading
    @Provide() private panelLoading:Boolean = false;//loading

    @Provide() private pagnition: any = pagnition;
    @Provide() private pageIndex: number = 1;
    @Provide() private pageSize: number = 20;
    @Provide() private pagerCount: number = 0;


    @Provide() private baseForm: any = {} //基本信息
    @Provide() private identityForm: any = {} //身份信息
    @Provide() private workForm: any = {}; //工作信息
    @Provide() private familyForm: any = {}; //家庭信息
    @Provide() private occupancyForm: any = {};//工作经历
    @Provide() private rewardForm: any = {};//奖惩记录
    @Provide() private rewardItem: any = {};//
    @Provide() private updatetime: any = '';//
    @Provide() private updateTime: any = '';//

    @Provide() private type: any = 'add';//


    @Provide() private officeForm: any = {
        id:0,
        officestatus: '',
        officetime:'',
        officeTime:'',
        reason:''
    };

    @Provide() private panelOfficeForm: any = {
        id:0,
        officestatus: '',
        officetime:'',
        officeTime:'',
        reason:''
    };
    @Provide() private attachFileList: any = [];


    @Provide() private ArchiveAttachments:any =  {
        listList:[{
            id:0,
            attachmentname:'',
            attachmentid:'',
            panelstatus:0
        }],
        panelstatus:0
    };
    
   @Provide() private rules: any =  {
        officestatus: [
            { required: true, message: 'please enter', trigger: 'blur' },
        ],
        officeTime: [
            { required: true, message: 'please enter', trigger: 'blur' },
        ],
        reason: [
            { required: true, message: 'please enter', trigger: 'blur' },
        ]
    };

    private created () {
        this.baseUserInfo = this.$route.query
        this.baseUserInfo.common = JSON.parse(this.baseUserInfo.common)
        let type = localStorage.getItem('userType') ||'add'
        let archiveid = localStorage.getItem('archiveid') || 0
        this.archiveid = archiveid 
        this.userid = this.$route.query.id
        if(type === 'add'){
            this.detailInfo = ''
            //说明为新增
            this.baseAdd = true
            this.baseDetail = false
            this.identityAdd = false
            this.identityDetail = false
            this.workAdd = false
            this.workDetail = false
            this.familyAdd = false
            this.familyDetail = false
            this.occupancyAdd = false
            this.occupancyDetail = false
            this.rewardAdd = false
            this.rewardDetail = false
            this.getRecordList(false)
        }else if(type === 'look'){
            //进详情页
            this.type = 'look'
            this.getDetailInfo(this.$route.query,'detail')
            this.getRecordList(false)
        }
    }
    
    private async getDetailInfo(row:any,type:any){
        let obj = {
            ArchiveID:this.archiveid,
            UserID:row.id
        }
        const { getArchiveReq, getArchiveRequest }: any = await import("@/request/peopleManagement");
        let res = await getArchiveRequest.handleHttp(getArchiveReq(obj), this);
        if (res && res.right) {
            this.archiveid = res.archive.archiveid;
            this.updatetime = timeFormatSecond(res.archive.updatetime)
            this.updateTime = res.archive.updatetime
            // 更新详情之后，更新记录
            this.getRecordList(false)
            let officeForm = JSON.parse(JSON.stringify(res.archive.office));

            this.officeForm = JSON.parse(JSON.stringify(res.archive.office));
            let time = officeForm.officetime && officeForm.officetime != 0 ? String(officeForm.officetime) : ''
            let times = time ? time.slice(0,4) + '-' + time.slice(4,6) + '-' + time.slice(6,8) : ''
            this.officeForm.officeTime = JSON.parse(JSON.stringify(times))
            if(type != 'delete'){
                //如果是删除则在删除里更新对应状态
                this.baseAdd = false
                this.identityAdd = false
                this.workAdd = false
                this.familyAdd = false
                this.occupancyAdd = false
                this.rewardAdd = false

                this.baseDetail = true
                this.identityDetail = true
                this.workDetail = true
                this.familyDetail = true
                this.occupancyDetail = true
                this.rewardDetail = true
            }
            

            this.detailInfo = res.archive
        } else {
        }
    }
    private initForm (form:any,type:any) {
        switch (type) {
            case '1':
                this.baseForm = form 
                break;
            case '2':
                this.identityForm = form
                break; 
            case '3':
                this.workForm = form
                break; 
            case '4':
                this.familyForm = form
                break; 
            case '5':
                this.occupancyForm = form
                break;
            case '6':
                this.rewardForm = form
                break;
            default:
                break;
        }
    }


    private async submitForm (form:any,type:string) {
        // this.panelOfficeForm = JSON.parse(JSON.stringify(this.officeForm));
        switch (type) {
            case '1':
                this.baseForm = form 
                this.baseLoading = true
                break;
            case '2':
                this.identityForm = form
                this.identityLoading = true
                break; 
            case '3':
                this.workForm = form
                this.workLoading = true
                break; 
            case '4':
                this.familyForm = form
                this.familyLoading = true
                break; 
            case '5':
                this.occupancyForm = form
                this.occupancyLoading = true
                break;
            case '6':
                this.rewardForm = form
                this.rewardLoading = true
                break;
            case '7':
                this.panelOfficeForm = form
                this.panelLoading = true
                break;
            default:
                break;
        }
        let object:any = {
            UpdateTime : 0, // 更新时间
            ArchiveID : this.archiveid, // ArchiveID为0新建，否则更新
            ArchivePersonal :  this.baseForm,// 个人资料
            ArchiveIdentity :this.identityForm,// 身份信息
            ArchiveWork:this.workForm,// 工作档案
            ArchiveFamily:this.familyForm,// 家庭背景
            ArchiveOccupancys:this.occupancyForm,// 工作经历
            ArchiveRewards:this.rewardForm,// 奖惩记录
            ArchiveOffice:this.panelOfficeForm,// 员工状态
            ArchiveAttachments:this.ArchiveAttachments, // 附件列表
            UserID:this.userid
        } 
        let res
        if(this.archiveid === 0){
            //add
            const { getSaveArchiveReq, getSaveArchiveRequest }: any = await import("@/request/peopleManagement");
            res = await getSaveArchiveRequest.handleHttp(getSaveArchiveReq(object), this);
        }else{
            //update
            const { getSaveArchiveReq, updateArchiveRequest }: any = await import("@/request/peopleManagement");
            res = await updateArchiveRequest.handleHttp(getSaveArchiveReq(object), this);
        }

        if (res && res.right) {
            switch (type) {
                case '1':
                    this.baseAdd = false
                    this.baseDetail = true
                    this.baseLoading = false
                    break;
                case '2':
                    this.identityAdd = false
                    this.identityDetail = true
                    this.identityLoading = false
                    break; 
                case '3':
                    this.workAdd = false
                    this.workDetail = true
                    this.workLoading = false
                    break; 
                case '4':
                    this.familyAdd = false
                    this.familyDetail = true
                    this.familyLoading = false
                    break; 
                case '5':
                    this.occupancyAdd = false
                    this.occupancyDetail = true
                    this.occupancyLoading = false
                    break;
                case '6':
                    this.rewardAdd = false
                    this.rewardDetail = true
                    this.rewardLoading = false
                    break;
                case '7':
                    this.panelLoading = false
                    this.showPanelDialog = false
                    // this.resetPanel('panelOfficeForm')
                    break;
                default:
                    break;
            }
            this.archiveid = res.archiveid
            this.getDetailInfo(res,'add')
            // archiveid
            this.$message({
                type: "success",
                message: "submit successfully!"
            });
            localStorage.setItem('userType', 'look');
            localStorage.setItem('archiveid', res.archiveid);
            if(type == '7'){
                let ref: any = this.$refs['panelOfficeForm'];
                ref.resetFields();
            }
        }else{
            switch (type) {
                case '1':
                    this.baseLoading = false
                    break;
                case '2':
                    this.identityLoading = false
                    break; 
                case '3':
                    this.workLoading = false
                    break; 
                case '4':
                    this.familyLoading = false
                    break; 
                case '5':
                    this.occupancyLoading = false
                    break;
                case '6':
                    this.rewardLoading = false
                    break;
                case '7':
                    this.panelLoading = false
                    this.showPanelDialog = true
                    break;
                default:
                    break;
            }
        }
    }

    private resetForm(type:any){
        if(this.type === 'look'){
            switch (type) {
                case '1':
                    this.baseAdd = false
                    this.baseDetail = true
                    break;
                case '2':
                    this.identityAdd = false
                    this.identityDetail = true
                    break; 
                case '3':
                    this.workAdd = false
                    this.workDetail = true
                    break; 
                case '4':
                    this.familyAdd = false
                    this.familyDetail = true
                    break; 
                case '5':
                    this.occupancyAdd = false
                    this.occupancyDetail = true
                    break;
                case '6':
                    this.rewardAdd = false
                    this.rewardDetail = true
                    break;
                default:
                    break;
            }
        }else if(this.type === 'add'){
            switch (type) {
                case '1':
                    this.baseAdd = false
                    this.baseDetail = false
                    break;
                case '2':
                    this.identityAdd = false
                    this.identityDetail = false
                    break; 
                case '3':
                    this.workAdd = false
                    this.workDetail = false
                    break; 
                case '4':
                    this.familyAdd = false
                    this.familyDetail = false
                    break; 
                case '5':
                    this.occupancyAdd = false
                    this.occupancyDetail = false
                    break;
                case '6':
                    this.rewardAdd = false
                    this.rewardDetail = false
                    break;
                default:
                    break;
            }
        }
    }

    private addForm (type:any){
        this.type = 'add'
        switch (type) {
            case '1':
                this.baseAdd = true
                this.baseDetail = false
                break;
            case '2':
                this.identityAdd = true
                this.identityDetail = false
                break; 
            case '3':
                this.workAdd = true
                this.workDetail = false
                break; 
            case '4':
                this.familyAdd = true
                this.familyDetail = false
                break; 
            case '5':
                this.occupancyAdd = true
                this.occupancyDetail = false
                break;
            case '6':
                this.rewardAdd = true
                this.rewardDetail = false
                break;
            default:
                break;
        }
    }    
    
    private editForm (type:any) {
        this.type = 'look'
        switch (type) {
            case '1':
                this.baseAdd = true
                this.baseDetail = false
                break;
            case '2':
                this.identityAdd = true
                this.identityDetail = false
                break; 
            case '3':
                this.workAdd = true
                this.workDetail = false
                break; 
            case '4':
                this.familyAdd = true
                this.familyDetail = false
                break; 
            case '5':
                this.occupancyAdd = true
                this.occupancyDetail = false
                break;
            case '6':
                this.rewardAdd = true
                this.rewardDetail = false
                break;
            default:
                break;
        }
    }

    private async deleteForm(type:any){
        switch (type) {
            case '1':
                this.detailInfo.personal.panelstatus = 1
                break;
            case '2':
                this.detailInfo.identity.panelstatus = 1
                break; 
            case '3':
                this.detailInfo.work.panelstatus = 0
                //该项实际不可删除，所以写了假删除
                break; 
            case '4':
                this.detailInfo.family.panelstatus = 1
                this.detailInfo.family.contactList.forEach((item:any) => {
                    item.panelstatus = 1
                })
                break; 
            case '5':
                this.detailInfo.occupancy.panelstatus = 1
                this.detailInfo.occupancy.listList.forEach((item:any) => {
                    item.panelstatus = 1
                })
                break;
            case '6':
                this.detailInfo.reward.panelstatus = 1
                this.detailInfo.reward.listList.forEach((item:any) => {
                    item.panelstatus = 1
                })
                break;
            default:
                break;
        }
         let object:any = {
                UpdateTime : this.updateTime, // 更新时间
                ArchiveID : this.detailInfo.archiveid, // ArchiveID为0新建，否则更新
                ArchivePersonal :  this.detailInfo.personal,// 个人资料
                ArchiveIdentity :this.detailInfo.identity,// 身份信息
                ArchiveWork:this.detailInfo.work,// 工作档案
                ArchiveFamily:this.detailInfo.family,// 家庭背景
                ArchiveOccupancys:this.detailInfo.occupancy,// 工作经历
                ArchiveRewards:this.detailInfo.reward,// 奖惩记录
                ArchiveOffice:this.detailInfo.office,// 员工状态
                ArchiveAttachments:this.detailInfo.attachment, // 附件列表
                UserID:this.detailInfo.userid
            } 

            const { getSaveArchiveReq, deleteArchivePanelRequest }: any = await import("@/request/peopleManagement");
            let res = await deleteArchivePanelRequest.handleHttp(getSaveArchiveReq(object), this);
            if (res && res.right){
                // this.updatetime = timeFormatSecond(res.archive.updatetime)
                // this.updateTime = res.archive.updatetime
                
                //删除成功
                 this.$message({
                    type: "success",
                    message: "delete successfully!"
                });
                // this.archiveid = 0
                this.getDetailInfo(res,'delete')
                switch (type) {
                    case '1':
                    this.baseAdd = false
                    this.baseDetail = false
                    break;
                case '2':
                    this.identityAdd = false
                    this.identityDetail = false
                    break; 
                case '3':
                    this.workAdd = false
                    this.workDetail = false
                    break; 
                case '4':
                    this.familyAdd = false
                    this.familyDetail = false
                    break; 
                case '5':
                    this.occupancyAdd = false
                    this.occupancyDetail = false
                    break;
                case '6':
                    this.rewardAdd = false
                    this.rewardDetail = false
                    break;
                default:
                    break;
                }
            }
    }
   
    //编辑员工当前状态
    private editRecord(){
       this.showPanelDialog = true
    }

    private submitPanel (formName:string) {
        let ref: any = this.$refs[formName];
        ref.validate((valid:any) => {
            if (valid) {
                this.panelOfficeForm.id = this.officeForm.id ? this.officeForm.id : 0
                this.panelOfficeForm.officetime = this.panelOfficeForm.officeTime.replace(/-/g,'')
                this.panelOfficeForm.officestatus = Number(this.panelOfficeForm.officestatus)
                this.submitForm(this.panelOfficeForm,'7')
            } else {
                return false;
            }
        });

        
    }

    private resetPanel(formName:string){
        let ref: any = this.$refs[formName];
        ref.resetFields();
        this.showPanelDialog = false
    }

    //获取 入离职记录
    private async getRecordList (flag:any) {
        if(flag === true){
            this.showPanelRecord = true
        }
        let obj = {
            Page: {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
            },
            ArchiveID:this.archiveid,
            UserID:this.userid
        }

        const { getOfficeListReq, getOfficeListRequest }: any = await import("@/request/peopleManagement");
        let res = await getOfficeListRequest.handleHttp(getOfficeListReq(obj), this);
        if (res && res.right) {
            let list = res.listList
            list.forEach((item:any) => {
                item.status = item.officestatus == 1 ? this.$tc('formWrh.onJob') : item.officestatus == 2 ? this.$tc('formWrh.quit'): ''
                let time = item.officetime && item.officetime != 0 ? String(item.officetime) : ''
                item.time = time.slice(0,4) + '-' + time.slice(4,6) + '-' + time.slice(6,8)

            });
            this.panelRecord = res.listList
            this.pagerCount = res.pageout.total

        } else {
        }
    }

    private panelChange (val:any){
        this.panelOfficeForm.officeTime = ''
        this.panelOfficeForm.officetime = ''
        if(val == 1){
            //change reward
            this.panelOfficeForm.reason = ''
        }
        this.$forceUpdate()
    }
  
    private dateChange(val:any){
        this.$forceUpdate()
    }

    // record 
    private handleCurrentChange(val: any) {
        this.pageIndex = Number(val);
        this.getRecordList(true);
    }
    //点击上一页
    private handlePrevChange(val: any) {
        if (this.pageIndex > 0) {
            this.getRecordList(true);
        }
    }
    //点击下一页
    private handleNextChange(val: any) {
        this.getRecordList(true);
    }

    private handleSizeChange(val: any) {
        this.pageSize = Number(val);
        this.getRecordList(true);
    }

    private beforeClose (){
        this.resetPanel('panelOfficeForm')
    }
    // private  beforeAvatarUpload (file:any) {
    //     const isJPG = file.type === 'image/jpeg';
    //     const isLt2M = file.size / 1024 / 1024 < 2;

    //     if (!isJPG) {
    //         this.$message.error('上传头像图片只能是 JPG 格式!');
    //     }
    //     if (!isLt2M) {
    //         this.$message.error('上传头像图片大小不能超过 2MB!');
    //     }
    //     return isJPG && isLt2M;
    // }

    // private handleRemove(file:any, fileList:any) {
    // }

    // private handlePreview(file:any) {
    // }

    // private handleExceed(files:any, fileList:any) {
    //     this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // }

    // private beforeRemove(file:any, fileList:any) {
    //     return this.$confirm(`确定移除 ${ file.name }？`);
    // }
}
